<template>
	<div class="link-block">
		<div class="link-block__title" v-if="title">
			{{ title }}
		</div>
		<template v-if="links && links.length > 0">
			<NuxtLinkLocale
				v-for="link in links"
				:key="link.fields.link.value.href"
				class="link-block_link"
				:class="
					store.context?.itemPath.includes(link?.fields?.link?.value?.href)
						? ' router-link-active'
						: ''
				"
				:to="link.fields.link.value.href"
				@click="store.closeSideNav"
			>
				{{ link.fields.link.value.text }}
			</NuxtLinkLocale>
		</template>
	</div>
</template>

<script setup>
const store = useAppStore();

const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const title = computed(() => props.fields?.title?.value);
const links = computed(() => props.fields?.links || []);
</script>

<style lang="scss">
.link-block {
	display: flex;
	flex-direction: column;
	align-items: center;
	color: var(--color-white, #fff);
	padding: 0 var(--spacing-2, 16px);
	gap: var(--spacing-5, 40px);

	.link-block__title {
		font-family: var(--primary-font, sans-serif);
		margin-bottom: var(--spacing-2, 16px);
		font-size: var(--text-2xl, 32px);
		text-align: center;
		font-weight: 900;
		line-height: 110%;
		text-transform: uppercase;
	}

	.link-block_link {
		width: auto;
		min-width: fit-content;
		color: var(--color-white, #fff);
		font-family: var(--primary-font, sans-serif);
		font-size: 18px;
		font-style: normal;
		font-weight: 300;
		line-height: 140%;
		text-decoration: none;
		padding: 0 var(--spacing-1, 8px);
		display: flex;
		align-items: flex-end;
		justify-content: center;
		transition: color 0.2s ease-in-out;

		&.router-link-active {
			color: var(--primary-color, #fd470b);
			position: relative;
			padding-bottom: var(--spacing-1, 8px);

			&:after {
				content: "";
				height: 2px;
				background-color: var(--primary-color, #fd470b);
				width: calc(100% - 16px);
				position: absolute;
				left: var(--spacing-1, 8px);
				right: var(--spacing-1, 8px);
				bottom: 0px;
			}
		}
	}
}
</style>
